import React from "react";
import "../App.css"; // assuming shared styles are here

const Disclaimer = () => {
  return (
    <div className="bottom-disclaimer">
      <p>
        This website does not provide medical advice. All content is for informational and research purposes only and is not a substitute for professional medical advice, diagnosis, or treatment.
      </p>
    </div>
  );
};

export default Disclaimer;
